import Vue from 'vue'
import App from './App.vue'
import 'lib-flexible/flexible'
import router from './router'
import VueResource from 'vue-resource'
import Vuex from 'vuex';
import { Confirm, Toast, Loading } from 'vue-dialog-simple'
import { ToastFix } from "./toastFix";
import eventEmitter from './assets/plugins/eventEmitter.js'
import VueCompositionApi from  '@vue/composition-api'

// 引入自定义事件
Vue.use(eventEmitter, ['onResume', 'onPause'])
Vue.use(Confirm)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(ToastFix)

Vue.use(VueCompositionApi)

Vue.config.productionTip = false



new Vue({
  router,
  render: h => h(App),
}).$mount('#app')


